import { headerV2Tokens, livescoreHeaderTokens, oddsTokens } from './general-components';

export const footballSingleEventTokens = {
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  roundColor: '',
  oddsSelectionBackgroundColor: '',
  oddItemHoverColor: '',
};

export const footballLineupsTokens = {
  footballFieldTone: '',
  hiContrast: '',
  collapsibleBgColor: '',
  footballFieldLineColor: '',
  lineupsHeaderContainerBgColor: '',
  lineupsRowEvenBgColor: '',
  lineupsRowOddBgColor: '',
  lineupsSecondaryTextColor: '',
  mobileTabsSelectedBgColor: '',
  lineupsPrimaryBackgroundColor: '',
};

export const footballTeamH2HTokens = {
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  progressOneBgColor: '',
  progressTwoBgColor: '',
  subHeaderBgColor: '',
};

export const footballTeamMatchH2HTokens = {
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  oddsContainerPrimaryBgColor: '',
  progressOneBgColor: '',
  progressTwoBgColor: '',
  subHeaderBgColor: '',
};

export const footballMatchesH2HTokens = {
  hiContrast: '',
  rowBackgroundColor: '',
  standingsLinkColor: '',
  pillBackgroundColor: '',
  pillActiveBackgroundColor: '',
  surfaceBackgroundColor: '',
};

export const footballStandingsTokens = {
  primaryBackgroundColor: '',
  hiContrast: '',
  rowBackgroundColor: '',
  relegationColor: '',
  relegationPlayoff: '',
  promotion: '',
  promotionPlayoff: '',
  championshipPlayoff: '',
  tierTwo: '',
  tierTwoPlayoff: '',
  topPlayoff: '',
  top: '',
  dropdownBtnColor: '',
  dropdownBorderColor: '',
};

export const footballGroupStandingsTokens = {
  primaryBackgroundColor: '',
  hiContrast: '',
  rowBackgroundColor: '',
  relegationColor: '',
  relegationPlayoff: '',
  promotion: '',
  promotionPlayoff: '',
  championshipPlayoff: '',
  tierTwo: '',
  tierTwoPlayoff: '',
  topPlayoff: '',
  top: '',
  dropdownBtnColor: '',
  dropdownBorderColor: '',
};

export const footballKnockoutTokens = {
  hiContrast: '',
  statusBadgeBgColor: '',
  statusBageTextColor: '',
  knockoutBgColor: '',
  knockoutHeaderBgColor: '',
  knockoutHeaderBorderColor: '',
  knockoutGameBgColor: '',
  knockoutGameBorderColor: '',
  teamLostColor: '',
};

export const footballKnockoutStandingsTokens = {
  ...footballKnockoutTokens,
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  relegationColor: '',
  relegationPlayoff: '',
  promotion: '',
  promotionPlayoff: '',
  championshipPlayoff: '',
  tierTwo: '',
  tierTwoPlayoff: '',
  topPlayoff: '',
  top: '',
  dropdownBtnColor: '',
  dropdownBorderColor: '',
};

export const footballTimelineTokens = {
  timelineBackgroundColor: '',
  secondaryHeaderTextColor: '',
  timelineTabBackgroundColor: '',
  tabTextColor: '',
};

export const footballMatchCenterTokens = {
  ...footballSingleEventTokens,
  ...footballLineupsTokens,
  ...footballTeamH2HTokens,
  ...footballStandingsTokens,
  ...footballGroupStandingsTokens,
  ...footballKnockoutStandingsTokens,
  ...footballTimelineTokens,
  ...oddsTokens,
  matchCenterPrimaryBackgroundColor: '',
  tabBackgroundColor: '',
  tabActiveTextColor: '',
  tabActiveBackgroundColor: '',
  tabMenuBorderColor: '',
};

export const footballTeamProgrammeTokens = {
  ...headerV2Tokens,
  ...oddsTokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  standingsLinkColor: '',
  pillActiveBackgroundColor: '',
  pillBackgroundColor: '',
  dropdownBorderColor: '',
  dropdownBtnColor: '',
  primaryBackgroundColor: '',
};

export const footballTournamentProgrammeTokens = {
  ...headerV2Tokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  oddsContainerPrimaryBgColor: '',
  oddsSelectionBackgroundColor: '',
  oddItemHoverColor: '',
  standingsLinkColor: '',
  pillActiveBackgroundColor: '',
  pillBackgroundColor: '',
  dropdownBorderColor: '',
  dropdownBtnColor: '',
  primaryBackgroundColor: '',
};

export const footballLivescoreTokens = {
  ...livescoreHeaderTokens,
  ...oddsTokens,
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  standingsLinkColor: '',
};

export const footballMostDecoratedTokens = {
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  pillBackgroundColor: '',
  dropdownBtnColor: '',
  subHeaderBgColor: '',
  dropdownBorderColor: '',
};

export const footballPlayerProfileTokens = {
  hiContrast: '',
  playerPrimaryBackgroundColor: '',
  statsContainerBackgroundColor: '',
  playerSecondaryTextColor: '',
  playerBioBackgroundColor: '',
  playerBioTextColor: '',
  playerProfileBorderColor: '',
  matchRowBgColor: '',
  tournamentHeaderBgColor: '',
};

export const footballPlayerH2HTokens = {
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  progressOneBgColor: '',
  progressTwoBgColor: '',
  subHeaderBgColor: '',
};

export const footballRoundTokens = {
  ...oddsTokens,
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  statusBadgeBgColor: '',
  statusBadgeTextColor: '',
  standingsLinkColor: '',
  pillBackgroundColor: '',
  dropdownBtnColor: '',
};

export const footballStakesTokens = {
  hiContrast: '',
  roundColor: '',
  stakesBgColor: '',
  teamStakesBorderColor: '',
  stakesSelectionBgColor: '',
  stakesSelectedBgColor: '',
  selectedStakeColor: '',
  accentPrimaryBgColor: '',
  accentContrastColor: '',
  stakeInputBorderColor: '',
};

export const footballTeamProfileTokens = {
  hiContrast: '',
  teamPrimaryBackgroundColor: '',
  statsContainerBackgroundColor: '',
  teamSecondaryTextColor: '',
  matchRowBgColor: '',
  tournamentHeaderBgColor: '',
  emptyTeamImage: '',
};

export const footballTeamSquadTokens = {
  hiContrast: '',
  primaryBackgroundColor: '',
  sportEntityContainerPrimaryBgColor: '',
  rowBackgroundColor: '',
  pillActiveBackgroundColor: '',
  pillBackgroundColor: '',
  dropdownBtnColor: '',
  dropdownBorderColor: '',
};

export const footballTopScorersTokens = {
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  pillBackgroundColor: '',
  dropdownBtnColor: '',
  subHeaderBgColor: '',
  dropdownBorderColor: '',
};
